const SSR_CATEGORIES = [
    {
        key: 'mobility',
        label: 'Mobility',
        codes: ['WCHR', 'WCHS', 'WCHC', 'WCBW', 'WCBD'],
    },
    {
        key: 'sensory',
        label: 'Sensory',
        codes: ['DEAF', 'BLND'],
    },
    {
        key: 'infantLap',
        label: 'Infant on lap',
        codes: ['INFT'],
    },
    {
        key: 'infantSeat',
        label: 'Infant in own seat',
        codes: ['INST', 'INFS'],
    },
    {
        key: 'umnr',
        label: 'Unaccompanied child',
        codes: ['UMNR'],
    },
    {
        key: 'medical',
        label: 'Medical',
        codes: ['DPNA', 'MAAS', 'STCR', 'BSCT', 'ESAN', 'PETC_ALLERGIC'],
    },
    {
        key: 'serviceAnimal',
        label: 'Service animals',
        codes: ['AVIH_SERVICE', 'PETC_SERVICE'],
    },
];

const CATEGORY_BY_CODE = new Map();
for (const category of SSR_CATEGORIES) {
    for (const code of category.codes) {
        CATEGORY_BY_CODE.set(code, category.key);
    }
}

const CATEGORY_BY_KEY = new Map(SSR_CATEGORIES.map((category) => [category.key, category]));

const serviceCode = (service) => {
    const code = typeof service === 'string' ? service : service?.code;
    return code ? String(code).toUpperCase() : '';
};

export { SSR_CATEGORIES };

export const categoryKeyForCode = (code) => {
    const normalized = serviceCode(code);
    if (!normalized) return null;
    if (CATEGORY_BY_CODE.has(normalized)) return CATEGORY_BY_CODE.get(normalized);
    if (normalized.startsWith('WC')) return 'mobility';
    if (normalized.startsWith('MEDA')) return 'medical';
    return null;
};

export const categoryByKey = (key) => CATEGORY_BY_KEY.get(key) || null;

export const passengerCategoryKeys = (passenger) => {
    const matched = new Set();
    const services = Array.isArray(passenger?.services) ? passenger.services : [];
    for (const service of services) {
        const key = categoryKeyForCode(serviceCode(service));
        if (key) matched.add(key);
    }
    if (passenger?.isInfant === true) matched.add('infantLap');
    if (passenger?.wheelchair === true) matched.add('mobility');
    if (String(passenger?.passengerType || '').toUpperCase() === 'INS') {
        matched.add('infantSeat');
    }
    return SSR_CATEGORIES.map((category) => category.key).filter((key) => matched.has(key));
};

export const countSpecialNeedsCategories = (passengers) => {
    const byKey = Object.fromEntries(SSR_CATEGORIES.map((category) => [category.key, 0]));
    let parent = 0;
    for (const passenger of passengers || []) {
        const keys = passengerCategoryKeys(passenger);
        if (keys.length === 0) continue;
        parent += 1;
        for (const key of keys) byKey[key] += 1;
    }
    return { parent, byKey };
};

export const passengerMatchesSpecialNeedsCategories = (passenger, categoryKeys) => {
    const keys = passengerCategoryKeys(passenger);
    if (!Array.isArray(categoryKeys) || categoryKeys.length === 0) {
        return keys.length > 0;
    }
    const selected = new Set(categoryKeys);
    return keys.some((key) => selected.has(key));
};

export const specialNeedsBadges = (passenger) => {
    const services = Array.isArray(passenger?.services) ? passenger.services : [];
    const seen = new Set();
    const badges = [];
    for (const service of services) {
        const code = serviceCode(service);
        if (!code || seen.has(code)) continue;
        const categoryKey = categoryKeyForCode(code);
        if (!categoryKey) continue;
        seen.add(code);
        badges.push({
            code,
            categoryKey,
            categoryLabel: categoryByKey(categoryKey)?.label || categoryKey,
        });
    }
    return badges;
};
